import PromisedResource from './PromisedResource'

export default class LandingPagesResource extends PromisedResource {
  constructor({ remote }) {
    super(remote.query(q => q.findRecords('landingPage')))
  }
}
